const sanitizeText = (text) => text
    .replace(/(\u{00A0}|\u{3000})/gu, ' ')
    .replace(/\p{Mc}(?=\0)/gu, '$&\u200B');
export default sanitizeText;
//# sourceMappingURL=sanitizeText.js.map